import React from 'react'
import { useTranslation } from 'react-i18next'

const MeunSideSetting = ({activeMenu,setActiveMenu}) => {
    const [t] = useTranslation('global')

    const handleClick = (newValue) => {
        setActiveMenu(newValue)
    }

    return (
        <div className='w-48 rounded text-xs'>
            <ul className=''>
                <li 
                    onClick={() => handleClick('ServicesLanguage')} 
                    className={`cursor-default p-2 border-b hover:bg-slate-100 hover:font-medium ${activeMenu === 'ServicesLanguage' && 'bg-slate-100 font-medium'}`}>
                        {t('settings.servicesLanguage')}
                </li>
            </ul>
        </div>
    )
}

export default MeunSideSetting
